export default __webpack_public_path__ + "static/media/VectorHIW.318309d7.svg";